// extracted by mini-css-extract-plugin
module.exports = {"informationWrap":"Information_informationWrap__2mrvV","iconWrap":"Information_iconWrap__2jYHp"};